import { PostAPI } from 'Components/Helper/Helpers';

export const Update = async (request) => {
    return PostAPI(request, 'MicroATMSetting/Update');
};

export const Select = async (request) => {
    return PostAPI(request, 'MicroATMSetting/Select');
};

export const IsOnOff = async (request) => {
    return PostAPI(request, 'MicroATMSetting/IsOnOff');
};
